import { log } from 'log';
import { useAppSubscription } from 'js/components/system/App/hooks';

export const useOnReconnect = ({
    sdk,
    nextTime,
    triggerGeolocation,
    setTransactionID,
    setLicense,
    setNextTime
}) => {
    useAppSubscription('server:socket:connect', async () => {
        if (!sdk || !nextTime) {
            return;
        }

        log('gcInfo', { event: 'connectionReconnected' });

        // unset current timeout
        setTransactionID(null);
        setLicense(null);
        setNextTime(0);

        await triggerGeolocation();
    }, [sdk, nextTime, triggerGeolocation]);
};
